module.exports = __webpack_public_path__ + "50979c65efa79da655cd4fe6311c07ea.png";